export default __webpack_public_path__ + "static/media/world-map.df3f7d55.png";